import type { Formation } from '@pn/core/domain/helper-data/formation';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { store } from 'src/application/storage/store';
import { formationsSlice } from './formationsSlice';

export const useFormationsStorage = () => {
  const { name, getInitialState } = formationsSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    formations: useSliceSelector((state) => state.formations),
    shouldLoad: useSliceSelector((state) => state.shouldLoad),
  };
};

export const formationsActions = () => {
  const { dispatch, getState } = store;
  const { actions, name } = formationsSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    receive: (formations: Formation[]) => dispatch(actions.receive(formations)),
    request: () => dispatch(actions.request()),
    error: () => dispatch(actions.error()),
  };
};
